var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6756 11.0039L16.9601 16.2881L16.2882 16.96L11.004 11.6755C9.83741 12.687 8.31503 13.2993 6.64982 13.2993C2.97716 13.2993 0 10.3221 0 6.64982C0 2.97716 2.97725 0 6.64982 0C10.3221 0 13.2993 2.97724 13.2993 6.64982C13.2993 8.31503 12.687 9.83741 11.6755 11.004L11.6756 11.0039ZM6.64981 12.3494C9.79762 12.3494 12.3494 9.79755 12.3494 6.64974C12.3494 3.50193 9.79762 0.949789 6.64981 0.949789C3.502 0.949789 0.949858 3.50193 0.949858 6.64974C0.949858 9.79755 3.502 12.3494 6.64981 12.3494Z",
    fill: "#27374d",
    stroke: "#27374d",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.111576ea661f8e6240be62067f77dd1b.svg";
export { ForwardRef as ReactComponent };